import { FC } from 'react';
import { Divider, Skeleton, Stack } from '@mui/material';
import styled from 'styled-components';
import { UserAvatar } from '@vs-online-only-app/ui';
import { Container } from './AssociatesList';

const AssociateGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  height: 58px;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0, 2)};
`;

const SummaryContainer = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(0.5, 2)};
`;

type Props = {
  count?: number;
};

const DEFAULT_ASSOCIATES_COUNT = 4;

const AssociatesListLoader: FC<Props> = ({
  count = DEFAULT_ASSOCIATES_COUNT,
}) => (
  <Container>
    <SummaryContainer>
      <Skeleton height={42} width="60%" />
      <Skeleton height={20} width={20} variant="rectangular" />
    </SummaryContainer>
    <Divider />
    {Array.from({ length: count }).map((_, index) => (
      <AssociateGrid key={index}>
        <Skeleton variant="circular">
          <UserAvatar />
        </Skeleton>
        <Stack>
          <Skeleton height={20} width="60%" />
          <Skeleton height={20} width="80%" />
        </Stack>
        <Skeleton height={20} width={20} variant="rectangular" />
      </AssociateGrid>
    ))}
  </Container>
);

export default AssociatesListLoader;
